import { render } from "./FailureView.vue?vue&type=template&id=2c874c11&scoped=true"
const script = {}

import "./FailureView.vue?vue&type=style&index=0&id=2c874c11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c874c11"]])

export default __exports__